module.exports = __webpack_public_path__ + "static/media/diamond-trevally.33951e29.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/diamond-trevally.png
// module id = 308
// module chunks = 0